/**
 * Shared Module Configuration for Super Admin Transactions
 * Defines API endpoints, status mappings, color palettes, and formatting utilities.
 */

export const MODULE_CONFIG = {
  name: "Transactions",
  title: "Transactions",
  subtitle: "Super Admin audit, payment status tracking, tenant revenue, and financial reporting.",
  singular: "Transaction",
  plural: "Transactions",
  routeBase: "/transactions",

  // API Endpoints
  endpoints: {
    listing: "transactions/super-admin/list",
    detail: "transactions/super-admin/detail",
    seed: "transactions/super-admin/seed-test-data",
  },

  // Status Filter Options
  statusOptions: [
    { id: "all", name: "All Statuses" },
    { id: "completed", name: "Completed" },
    { id: "pending", name: "Pending" },
    { id: "failed", name: "Failed" },
    { id: "refunded", name: "Refunded" },
  ],

  // High-contrast, accessibility-first status badges (Zero light grey)
  statusMap: {
    completed: {
      label: "Completed",
      bgClass: "bg-emerald-100 text-emerald-950 border-emerald-300 font-bold",
      dotClass: "bg-emerald-600",
    },
    success: {
      label: "Completed",
      bgClass: "bg-emerald-100 text-emerald-950 border-emerald-300 font-bold",
      dotClass: "bg-emerald-600",
    },
    pending: {
      label: "Pending",
      bgClass: "bg-amber-100 text-amber-950 border-amber-300 font-bold",
      dotClass: "bg-amber-600",
    },
    failed: {
      label: "Failed",
      bgClass: "bg-rose-100 text-rose-950 border-rose-300 font-bold",
      dotClass: "bg-rose-600",
    },
    refunded: {
      label: "Refunded",
      bgClass: "bg-indigo-100 text-indigo-950 border-indigo-300 font-bold",
      dotClass: "bg-indigo-600",
    },
    canceled: {
      label: "Canceled",
      bgClass: "bg-slate-200 text-slate-900 border-slate-300 font-bold",
      dotClass: "bg-slate-600",
    },
    cancelled: {
      label: "Cancelled",
      bgClass: "bg-slate-200 text-slate-900 border-slate-300 font-bold",
      dotClass: "bg-slate-600",
    },
  },
};

/**
 * Format currency amount with currency code
 */
export const formatCurrency = (amount, currency = "USD") => {
  if (amount === undefined || amount === null || amount === "") return "$0.00";
  const num = Number(amount);
  if (isNaN(num)) return `$${amount}`;
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency ? currency.toUpperCase() : "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  } catch (e) {
    return `$${num.toFixed(2)}`;
  }
};

import {
  capitalize,
  capitalizeSentence,
  formatDate,
  formatTime,
  getInitials,
} from "../../methods/methods";

export {
  capitalize,
  capitalizeSentence,
  formatDate,
  formatTime,
  getInitials,
};
